
import { useTranslation } from "react-i18next";
import { Grid, TextInput, Title } from "@mantine/core";

import { SelectCountry } from "../SelectCountry";
import { useClientBillingFormContext } from "./formContext";

export {
    ClientBillingFormProvider,
    parseClientBillingInput,
    useClientBillingForm,
} from "./formContext";

export const ClientBillingForm = () => {
    const { t } = useTranslation(["common"]);

    const clientBillingForm = useClientBillingFormContext();

    return (
        <>
            <Grid gutter={16} gutterMd={32}>
                <Grid.Col xs={12} md={6}>
                    <TextInput
                        {...clientBillingForm.getInputProps("name")}
                        label={t("billing_name")}
                        placeholder={t("billing_name")}
                    />
                </Grid.Col>
                <Grid.Col xs={12} md={6}>
                    <TextInput
                        {...clientBillingForm.getInputProps("email")}
                        label={t("billing_email")}
                        placeholder={t("billing_email")}
                    />
                </Grid.Col>
                <Grid.Col xs={12} md={6}>
                    <TextInput
                        {...clientBillingForm.getInputProps("cin")}
                        label={t("billing_cin")}
                        placeholder={t("billing_cin")}
                    />
                </Grid.Col>
                <Grid.Col xs={12} md={6}>
                    <TextInput
                        {...clientBillingForm.getInputProps("tin")}
                        label={t("billing_tin")}
                        placeholder={t("billing_tin")}
                    />
                </Grid.Col>
            </Grid>
            <Title mt="xl" mb={28} order={3} size={16} weight={600}>
                {t("billing_address")}
            </Title>
            <Grid gutter={16} gutterMd={32}>
                <Grid.Col xs={12} md={6}>
                    <TextInput
                        {...clientBillingForm.getInputProps("address.line1")}
                        label={t("address_line1")}
                        placeholder={t("address_line1")}
                    />
                </Grid.Col>
                <Grid.Col xs={12} md={6}>
                    <TextInput
                        {...clientBillingForm.getInputProps("address.city")}
                        label={t("address_city")}
                        placeholder={t("address_city")}
                    />
                </Grid.Col>
            </Grid>
            <Grid gutter={16} gutterMd={32}>
                <Grid.Col xs={12} md={6}>
                    <TextInput
                        {...clientBillingForm.getInputProps("address.postalCode")}
                        label={t("address_postalCode")}
                        placeholder={t("address_postalCode")}
                    />
                </Grid.Col>
                <Grid.Col xs={12} md={6}>
                    <SelectCountry {...clientBillingForm.getInputProps("address.country")} />
                </Grid.Col>
            </Grid>
        </>
    );
};
